import React from 'react';

const OffersTargets = ({ pixels, isCollapsed, collapsedItems, id }) =>
  pixels.length > 0 && (
    <div className="offers-list-table-cell offers-list-table-cell--targets">
      <ul className="offers-list-targets offer-values-list list-unstyled no-margin">
        {pixels.map((pixel, index) => {
          if (!isCollapsed || index < collapsedItems) {
            return (
              <li key={`targets_${pixel.id}_${id}_${index}`}>
                {pixel.group_name ? pixel.group_name : pixel.title}
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );

export default OffersTargets;
